import React, { useMemo } from 'react'
import { CollapsibleHeader } from 'client/fragments/listerFragment/components/Filters/Collapsible/CollapsibleHeader'
import { CollapsibleBody } from 'client/fragments/listerFragment/components/Filters/Collapsible/CollapsibleBody'

export const CollapsibleContext = React.createContext({})
export const ANIMATION_DURATION = 0.5

const Collapsible = ({ isCollapsed, setIsCollapsed, children, dataTestId, dataValue }) => {
  const context = useMemo(
    () => ({
      isCollapsed,
      setIsCollapsed
    }),
    [isCollapsed, setIsCollapsed]
  )

  const attributes = {}
  if (dataTestId) attributes['data-testid'] = dataTestId
  if (dataValue) attributes['data-value'] = dataValue

  return (
    <CollapsibleContext.Provider value={context}>
      <div className='mxd-mcollapse col-12' {...attributes}>
        {children}
      </div>
    </CollapsibleContext.Provider>
  )
}

Collapsible.Header = CollapsibleHeader
Collapsible.Body = CollapsibleBody
export default Collapsible
